"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordingStateLabel = exports.transcriptionStateLabel = exports.MeetingStatus = exports.RecordingState = exports.TranscriptionState = exports.RoomType = void 0;
var RoomType;
(function (RoomType) {
    RoomType[RoomType["Video"] = 0] = "Video";
    RoomType[RoomType["Audio"] = 1] = "Audio";
    RoomType[RoomType["Reception"] = 2] = "Reception";
})(RoomType || (exports.RoomType = RoomType = {}));
/**
 * Transcription state for MeetingMinutes - stored in DB as activity status
 */
var TranscriptionState;
(function (TranscriptionState) {
    TranscriptionState[TranscriptionState["NotStarted"] = 0] = "NotStarted";
    TranscriptionState[TranscriptionState["Transcribing"] = 1] = "Transcribing";
    TranscriptionState[TranscriptionState["Finished"] = 2] = "Finished";
})(TranscriptionState || (exports.TranscriptionState = TranscriptionState = {}));
/**
 * Recording state for MeetingMinutes - stored in DB as activity status
 */
var RecordingState;
(function (RecordingState) {
    RecordingState[RecordingState["NotStarted"] = 0] = "NotStarted";
    RecordingState[RecordingState["Recording"] = 1] = "Recording";
    RecordingState[RecordingState["Finished"] = 2] = "Finished";
})(RecordingState || (exports.RecordingState = RecordingState = {}));
var MeetingStatus;
(function (MeetingStatus) {
    MeetingStatus[MeetingStatus["Active"] = 0] = "Active";
    MeetingStatus[MeetingStatus["Finished"] = 1] = "Finished";
    MeetingStatus[MeetingStatus["Pending"] = 2] = "Pending";
    MeetingStatus[MeetingStatus["Scheduled"] = 7] = "Scheduled"; // In case meeting is scheduled, it could be started by any ws participant, only once at -15mins - due interval
})(MeetingStatus || (exports.MeetingStatus = MeetingStatus = {}));
exports.transcriptionStateLabel = {
    [TranscriptionState.NotStarted]: 'NotStarted',
    [TranscriptionState.Transcribing]: 'Transcribing',
    [TranscriptionState.Finished]: 'Finished'
};
exports.recordingStateLabel = {
    [RecordingState.NotStarted]: 'NotStarted',
    [RecordingState.Recording]: 'Recording',
    [RecordingState.Finished]: 'Finished'
};
//# sourceMappingURL=types.js.map